import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogContent, MatDialogRef} from "@angular/material/dialog";
import {ModalHeaderComponent} from '../../../layout/modal-header/modal-header.component';

@Component({
    selector: 'app-info-slack-channel',
    templateUrl: './info-slack-channel.component.html',
    styleUrls: ['./info-slack-channel.component.scss'],
    imports: [ModalHeaderComponent, MatDialogContent]
})
export class InfoSlackChannelComponent {
  constructor(
    public dialogRef: MatDialogRef<InfoSlackChannelComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {},
  ) { }
}
